import { useMemo } from 'react';

import type { ShareChannel } from 'src/app/pages/psf/promoteOrShare/shared/types';

const PSF_PROMOTE_OR_SHARE_CHANNEL_REWRITE: Readonly<Partial<Record<ShareChannel, ShareChannel>>> = {
	instagram: 'instagramStories',
};

export function usePsfPromoteOrShareChannelRemap(channels: readonly ShareChannel[]): readonly ShareChannel[] {
	return useMemo(() => {
		const rewritten = channels.map((ch) => PSF_PROMOTE_OR_SHARE_CHANNEL_REWRITE[ch] ?? ch);
		return Array.from(new Set(rewritten));
	}, [channels]);
}
